module.exports = __webpack_public_path__ + "static/img/4674_phase_function_Paper_PointsHejduk_Prediction.e9a172c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4674_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Lre1
// module chunks = 0